import { IEscalationDTO } from "../../../../setup/api/services/contractActions/models";
import { IMyInfoData } from "../../../../setup/api/services/profile/models";
import {
  ZENDESK_ADDITIONAL_REASONS,
  ZENDESK_ADMIN_CONTRACL_BASE_URL,
  ZENDESK_ADMIN_URL,
  ZENDESK_COMMENT,
  ZENDESK_CONTRACT_ID,
  ZENDESK_CONTRACT_SHORT_ID,
  ZENDESK_EMAIL_DOMAIN,
  ZENDESK_ESCALATION_REASON,
  ZENDESK_ESCALATION_TYPE,
  ZENDESK_PHONE_NUMBER,
} from "../../../../zendeskIntegration/contants";
import { ETicketType } from "../../../../zendeskIntegration/enums";
import {
  ICreateTicketFields,
  ICreateTicketRequestBody,
  ICreateTicketResponse,
} from "../../../../zendeskIntegration/models";

interface CreateTicketBody {
  subject: string;
  contractId: string;
  shortId: string;
  currentUser?: IMyInfoData;
  reasons?: string[];
  type?: ETicketType;
  additionalReasons?: string;
}
export const returnCreateTicketRequestBody = ({
  subject,
  currentUser,
  contractId,
  shortId,
  additionalReasons,
  reasons,
  type,
}: CreateTicketBody) => {
  const body: ICreateTicketRequestBody = {
    request: {
      subject: subject,
      comment: {
        body: ZENDESK_COMMENT.BODY,
      },
      requester: {
        name: currentUser?.profile.fullName || "",
        email: `${currentUser?.id}@${ZENDESK_EMAIL_DOMAIN}`,
      },
      custom_fields: [
        {
          id: ZENDESK_CONTRACT_SHORT_ID,
          value: shortId,
        },
        {
          id: ZENDESK_CONTRACT_ID,
          value: contractId,
        },
        {
          id: ZENDESK_ADDITIONAL_REASONS,
          value: additionalReasons || "",
        },
        {
          id: ZENDESK_ESCALATION_REASON,
          value: reasons || [],
        },
        {
          id: ZENDESK_ESCALATION_TYPE,
          value: type || [],
        },
        {
          id: ZENDESK_PHONE_NUMBER,
          value: currentUser?.phoneNumber || "",
        },
        {
          id: ZENDESK_ADMIN_URL,
          value: `${ZENDESK_ADMIN_CONTRACL_BASE_URL}/${contractId}`,
        },
      ],
    },
  };
  return body;
};
export const returnRequiredFieldItemFromResponse = (
  array: ICreateTicketFields[],
  id: number
) => {
  return array.filter((item) => {
    return item.id === id;
  });
};
export const returnEscalationDTO = (
  ticket: ICreateTicketResponse,
  userId: string
) => {
  const escalationDto: IEscalationDTO = {
    userId: userId,
    ticketId: ticket.request.id.toString(),
    reason: returnRequiredFieldItemFromResponse(
      ticket.request.fields,
      ZENDESK_ESCALATION_REASON
    ).join(","),
    message:
      returnRequiredFieldItemFromResponse(
        ticket.request.fields,
        ZENDESK_ADDITIONAL_REASONS
      )
        .at(0)
        ?.value?.toString() || "",
  };
  return escalationDto;
};
